import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EmployeePayrollData } from '../helpers/models/Models';

interface PayrollState {
    PayrollList: {
        data: EmployeePayrollData[];
    };
}

const initialState: PayrollState = {
    PayrollList: {
        data: [],
    },
};

const payrollSlice = createSlice({
    name: 'payroll',
    initialState,
    reducers: {
        STAFF_PAYROLL_LIST: (state, action: PayloadAction<EmployeePayrollData[]>) => {
            // Update the `data` property of `PayrollList`
            state.PayrollList.data = action.payload;
        },
    },
});

export const { STAFF_PAYROLL_LIST } = payrollSlice.actions;

export default payrollSlice.reducer;
